<mat-card *ngIf="reise">
  <mat-card-header>
    <mat-card-title>{{reise.name}}</mat-card-title>
    <mat-card-subtitle *ngIf="reise.schlagworte">{{reise.schlagworte}}</mat-card-subtitle>
  </mat-card-header>
  <img mat-card-image [src]="reise.image" *ngIf="reise.image">
  <mat-card-content>
    <p [innerHTML]="reise.kitestationHTML"></p>
    <p [innerHTML]="reise.skigebietHTML"></p>
    <p [innerHTML]="reise.unterkunftHTML"></p>
  </mat-card-content>
  <mat-card-actions>
    <button mat-button disabled>Bei Interesse bitte Kontakt aufnehmen</button>
  </mat-card-actions>
</mat-card>
